define.alias("shared/components/shared/profile-categorization/loading", "media/components/shared/profile-categorization/loading");